import { GameConstants } from "./../../GameConstants";
import { CompletedLayer } from "./CompletedLayer";
import { GameVars } from "../../GameVars";
import { Background } from "../background/Background";
import { HiLoGUI } from "./gui/HiLoGUI";
import { HiLoHUD } from "./HiLoHUD";
import { HiLoManager } from "../../managers/HiLoManager";
import { HiLoCardsContainer } from "./HiLoCardsContainer";
import { InfoLayerHiLo } from "./InfoLayerHiLo";
import { Table } from "../room/Table";
import { AudioManager } from "../../managers/AudioManager";
import { Translation } from "../../Translation";

export class HiLoScene extends Phaser.Scene {

    public static currentInstance: HiLoScene;

    private gui: HiLoGUI;
    private hud: HiLoHUD;
    private cardsContainer: HiLoCardsContainer;
    private completedLayer: CompletedLayer;
    private infoLayer: InfoLayerHiLo;

    constructor() {

        super("HiLoScene");

        HiLoScene.currentInstance = this;
    }

    public create(): void {

        GameVars.currentScene = this;

        HiLoManager.init();

        const background = new Background(this);
        this.add.existing(background);

        const table = new Table(this);
        this.add.existing(table);

        this.cardsContainer = new HiLoCardsContainer(this);
        this.add.existing(this.cardsContainer);

        this.hud = new HiLoHUD(this);
        this.add.existing(this.hud);

        this.gui = new HiLoGUI(this);
        this.add.existing(this.gui);

        this.completedLayer = new CompletedLayer(this);
        this.add.existing(this.completedLayer);

        AudioManager.playMusic("soundtrack_hi-lo", .5);
    }

    public showInfoLayer(): void {

        this.infoLayer = new InfoLayerHiLo(this);
        this.add.existing(this.infoLayer);
    }

    public hideInfoLayer(): void {

        this.gui.onInfoLayerHidden();

        this.infoLayer.destroy();
    }

    public onHeartLost(): void {

        this.time.delayedCall(400, function (): void {

            HiLoHUD.currentInstance.updateHearts();
            this.cameras.main.shake(200, .005);
        }, [], this);
    }

    public onGameOver(): void {

        this.hud.onGameOver();
        this.gui.onGameOver();
        this.cardsContainer.onGameOver();
        this.completedLayer.show(true);
    }

    public onGameCompleted(): void {

        this.hud.onGameCompleted();
        this.gui.onGameCompleted();
        this.cardsContainer.onGameContainer();
        this.completedLayer.show(false);
    }

    public onExtraHeart(): void {

        let extraHeart = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, Translation.getText("EXTRA_HEART"), { fontFamily: "Oswald-Medium", fontSize: "90px", color: "#ec3359" });
        extraHeart.setOrigin(.5);
        extraHeart.setScale(0);
        extraHeart.lineSpacing = -5;
        extraHeart.setStroke("#8a1131", 10);
        this.add.existing(extraHeart);

        this.tweens.add({
            targets: extraHeart,
            scaleX: GameVars.scaleX,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            onComplete: () => {
                this.time.addEvent({
                    delay: 1500, callback: () => {
                        this.tweens.add({
                            targets: extraHeart,
                            alpha: 0,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 500,
                            onComplete: () => {
                                extraHeart.destroy();
                                this.hud.updateExtraHearts();
                            },
                            onCompleteScope: this
                        });
                    }, callbackScope: this
                });
            },
            onCompleteScope: this
        });
    }

    public onReplay(): void {

        // por si deja de sonar el loop por cualquier razon
        AudioManager.playMusic("soundtrack_hi-lo", .5);

        this.completedLayer.visible = false;

        this.cardsContainer.onReplay();

        this.hud.onReplay();
        this.gui.onReplay();
    }
}
